import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import PropTypes from 'prop-types';

class OrganisationLogo extends React.Component {
    static propTypes = {
        OrganisationQuery: PropTypes.shape({
            loading: PropTypes.bool,
            error: PropTypes.object,
            organisation: PropTypes.object,
          }).isRequired,          
      } 
      
  render () {    
    const cssClass = this.props.className ? this.props.className : ''
    if (this.props.OrganisationQuery.loading) {      
      return (<img src="https://cdn.brikl.io/app/loading/placeholder.png" alt="placeholder" className={"placeholder "+cssClass} />)
    }
    if (this.props.OrganisationQuery.error) {
      console.log(this.props.OrganisationQuery.error)
      return (
      <div>Error
          <span className="hidden">{JSON.stringify(this.props.OrganisationQuery.error)}</span>
      </div>
    )
    }    
    const LIB_URL = 
    (document.location.hostname === "discovery.brikl.io") ? 
    "https://lib.brikl.io" 
    : 
    (document.location.hostname === "staging.discovery.brikl.io") ? 
    "https://staging.lib.brikl.io" 
    : 
    "https://staging.lib.brikl.io";
    return (    	
        <img alt="Logo" className={cssClass} src={
            this.props.OrganisationQuery.organisation.logoimage?
            LIB_URL+'/organisation/'+this.props.organisationid+'/logo/'+this.props.OrganisationQuery.organisation.logoimage
            : 'https://cdn.brikl.io/app/error/organisation.jpg'
        } />                    
    )
  }
}


const getOrganisation = gql`
query organisation ($id: String!){
    organisation (id: $id)
    {
        id,        
        logoimage,        
    }
  }`

const OrganisationLogoData = compose(
    graphql(getOrganisation, {
        name: 'OrganisationQuery',
        options: (ownProps) => ({
            variables: {
                id: ownProps.organisationid
            },
            operation: 'query',
        })
    }),
)(OrganisationLogo)

export default OrganisationLogoData


// WEBPACK FOOTER //
// ./src/organisations/OrganisationLogo.js